import React from 'react';
import { CaretDown, Lock } from 'phosphor-react';
import { useOptionsEntitlements } from '../../context/OptionsEntitlementsContext';

export const OptionsAnalyticsModuleCard = ({ module, expanded, onToggle }) => {
  const Icon = module.icon;
  const { isPro, openUpgradeModal } = useOptionsEntitlements();

  const handleClick = () => {
    if (!isPro) {
      openUpgradeModal("ANALYTICS");
      return;
    }
    onToggle(module.id);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`group flex w-full items-center justify-between gap-3 rounded-2xl border px-3.5 py-3 text-left text-white transition-[border-color,background-color] hover:border-white/18 hover:bg-white/[0.045] ${expanded ? 'border-white/20 bg-white/[0.06]' : 'border-white/10 bg-black/20'}`}
      data-testid={`options-analytics-module-card-${module.id}`}
      aria-expanded={expanded}
    >
      <div className="flex min-w-0 items-center gap-2.5">
        <span className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border border-white/8 bg-white/[0.04] text-white/60" data-testid={`options-analytics-module-card-${module.id}-icon`}>
          <Icon size={14} weight="bold" />
        </span>

        <div className="min-w-0">
          <div className="flex items-center gap-1.5">
            {!isPro && <Lock size={12} className="text-[#A855F7]" weight="fill" />}
            <p className="text-[13px] font-semibold leading-tight text-white/88" data-testid={`options-analytics-module-card-${module.id}-title`}>
              {module.title}
            </p>
            {!isPro && <span className="text-[9px] bg-[#A855F7]/10 text-[#A855F7] px-1.5 py-0.5 rounded-sm font-bold">PRO</span>}
          </div>
          <p className="mt-0.5 text-xs leading-tight text-white/45" data-testid={`options-analytics-module-card-${module.id}-summary`}>
            {isPro ? module.summary : (module.description || 'Análise detalhada disponível no GENI Options PRO.')}
          </p>
        </div>
      </div>

      {isPro ? (
        <CaretDown size={14} weight="bold" className={`shrink-0 text-white/30 transition-transform group-hover:text-white/50 ${expanded ? 'rotate-180' : ''}`} data-testid={`options-analytics-module-card-${module.id}-cta`} />
      ) : (
        <Lock size={14} weight="fill" className="shrink-0 text-[#F0B90B]" data-testid={`options-analytics-module-card-${module.id}-lock`} />
      )}
    </button>
  );
};

export default OptionsAnalyticsModuleCard;
